import { Col, Typography, Row } from "antd";
import { useEffect, useState } from "react";
import "../../styles/components.scss";
import { Header } from "../../components/Header";
import { FormattedMessage } from "react-intl";
import { CountrySelect } from "../../components/CountrySelect";
import SettingStore from "../../DataStores/SettingStore";
import { getType } from "../../utils/Utils";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;

const AdminMenu = ({ ToolStore }) => {
  const [country, setCountry] = useState({ id: -1, name: "" });
  const navigate = useNavigate();

  useEffect(() => {
    if (getType(ToolStore) == "user") {
      navigate("/tool");
    }
  }, []);

  return (
    <>
      <Header />

      <div style={{ textAlign: "center", marginTop: "10vh" }}>
        <Title level={2} className="roi--title-admin">
          <FormattedMessage id="admin" />
        </Title>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row gutter={24} style={{ marginRight: "1vh" }}>
          <Col
            span={20}
            className="roi--section-title"
            style={{
              marginTop: "1.5vh",
            }}
          >
            <span
              style={{
                marginLeft: "1vh",
                fontSize: SettingStore.fontSize * 1.75 + "rem",
              }}
            >
              <FormattedMessage id="global" />
            </span>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row gutter={24} style={{ marginRight: "1vh" }}>
          <span
            className="roi--section-title"
            style={{
              marginLeft: "2vh",
              fontSize: SettingStore.fontSize * 1.25 + "rem",
            }}
          ></span>
        </Row>
      </div>
      {/* <Row
        gutter={24}
        className="roi--background-section"
        style={{ marginRight: "1vh" }}
      >
        <Col
          span={20}
          className="roi--header-content"
          style={{ marginTop: "1.5vh" }}
        >
          <span
            style={{
              marginLeft: "1vh",
              fontSize: SettingStore.fontSize * 1.25 + "rem",
            }}
          >
            <FormattedMessage id="general" />
          </span>
        </Col>
        <Col
          span={4}
          style={{
            margin: "auto",
            padding: "10px",
            textAlign: "right",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "1.5vh" }}
            src="/images/icons/next.svg"
            className="roi--cursor"
          />
        </Col>
      </Row> */}
      <div style={{ marginTop: "2vh" }}>
        <Row
          gutter={24}
          className="roi--background-section roi--cursor"
          style={{ marginRight: "1vh" }}
          user
          onClick={() => navigate("/userManagement")}
        >
          <Col
            span={20}
            className="roi--header-content"
            style={{ marginTop: "1.5vh" }}
          >
            <span
              style={{
                marginLeft: "1vh",
                fontSize: SettingStore.fontSize * 1.25 + "rem",
              }}
            >
              <FormattedMessage id="userManagement" />
            </span>
          </Col>
          <Col
            span={4}
            style={{
              margin: "auto",
              padding: "10px",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "1.5vh" }}
              src="/images/icons/next.svg"
              className="roi--cursor"
            />
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row
          gutter={24}
          className="roi--background-section roi--cursor"
          style={{
            marginRight: "1vh",
            fontSize: SettingStore.fontSize * 1.25 + "rem",
          }}
          user
          onClick={() => navigate("/list")}
        >
          <Col
            span={20}
            className="roi--header-content"
            style={{ marginTop: "1.5vh" }}
          >
            <span
              style={{
                marginLeft: "1vh",
                fontSize: SettingStore.fontSize * 1.25 + "rem",
              }}
            >
              <FormattedMessage id="listOfAssessments" />
            </span>
          </Col>
          <Col
            span={4}
            style={{
              margin: "auto",
              padding: "10px",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "1.5vh" }}
              src="/images/icons/next.svg"
              className="roi--cursor"
            />
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row
          gutter={24}
          className="roi--background-section roi--cursor"
          style={{ marginRight: "1vh" }}
          onClick={() => navigate("/choice")}
        >
          <Col
            span={20}
            className="roi--header-content"
            style={{ marginTop: "1vh" }}
          >
            <span
              style={{
                marginLeft: "1vh",
                fontSize: SettingStore.fontSize * 1.25 + "rem",
              }}
            >
              <FormattedMessage id="manageInputs" />{" "}
            </span>
          </Col>
          <Col
            span={4}
            style={{
              margin: "auto",
              padding: "10px",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <img style={{ width: "1.5vh" }} src="/images/icons/next.svg" />
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row
          gutter={24}
          className="roi--background-section roi--cursor"
          style={{ marginRight: "1vh" }}
          onClick={() => navigate("/tool")}
        >
          <Col
            span={20}
            className="roi--header-content"
            style={{ marginTop: "1vh" }}
          >
            <span
              style={{
                marginLeft: "1vh",
                fontSize: SettingStore.fontSize * 1.25 + "rem",
              }}
            >
              <FormattedMessage id="useTheroi" />{" "}
            </span>
          </Col>
          <Col
            span={4}
            style={{
              margin: "auto",
              padding: "10px",
              textAlign: "right",
              alignItems: "center",
            }}
          >
            <img style={{ width: "1.5vh" }} src="/images/icons/next.svg" />
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row gutter={24} style={{ marginRight: "1vh" }}>
          <Col
            span={20}
            className="roi--section-title"
            style={{ marginTop: "1.5vh" }}
          >
            <span
              style={{
                marginLeft: "1vh",
                fontSize: SettingStore.fontSize * 1.25 + "rem",
              }}
            >
              <FormattedMessage id="settingsByCountry" />
            </span>
          </Col>
        </Row>
      </div>
      <CountrySelect
        style={{ marginLeft: "1vh", marginTop: "2vh", marginLeft: "1vh" }}
        setCountry={setCountry}
      />
      {country.name != "" && (
        <>
          <div style={{ marginTop: "2vh" }}>
            <Row
              gutter={24}
              className="roi--background-section roi--cursor"
              style={{ marginRight: "1vh" }}
              onClick={() =>
                navigate("/generalCountry", {
                  state: { country: country },
                })
              }
            >
              <Col
                span={20}
                className="roi--header-content"
                style={{ marginTop: "1vh" }}
              >
                <span
                  style={{
                    marginLeft: "1vh",
                    fontSize: SettingStore.fontSize * 1.25 + "rem",
                  }}
                >
                  <FormattedMessage id="general" />{" "}
                  {country.name != "" && "(" + country.name + ")"}
                </span>
              </Col>
              <Col
                span={4}
                style={{
                  margin: "auto",
                  padding: "10px",
                  textAlign: "right",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ width: "1.5vh", marginRight: "1vh" }}
                  src="/images/icons/next.svg"
                  className="roi--cursor"
                />
              </Col>
            </Row>
            <Row
              gutter={24}
              className="roi--background-section"
              style={{ marginRight: "1vh", marginTop: "2vh" }}
              onClick={() => {
                try {
                  navigate("/manageTemplates", { state: { country: country } });
                } catch (error) {
                  console.log(error);
                }
              }}
            >
              <Col
                span={20}
                className="roi--header-content roi--cursor"
                style={{ marginTop: "1vh" }}
              >
                <span
                  style={{
                    marginLeft: "1vh",
                    fontSize: SettingStore.fontSize * 1.25 + "rem",
                  }}
                >
                  <FormattedMessage id="manageTheTemplates" />{" "}
                  {country.name != "" && "(" + country.name + ")"}
                </span>
              </Col>
              <Col
                span={4}
                style={{
                  margin: "auto",
                  padding: "10px",
                  textAlign: "right",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ width: "1.5vh", marginRight: "1vh" }}
                  src="/images/icons/next.svg"
                  className="roi--cursor"
                />
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
};

export default AdminMenu;
